import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutTestimonialColumnDark = {
  factory: EElement({
    id: '2932b164-f8cd-4584-e4e8-3b6cb6cb0305',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('4fc4d513-ab34-d398-60a6-4d3b39c1c680')]),
      children: EList([
        EElement({
          id: 'e620dca8-a436-9cd0-f1e4-97c4b9b0b3cc',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '16bb9436-a156-9391-7515-463d6d87c8c0',
                type: qualify(Plugins.name('Basic'), Component.name('Heading')),
                data: ERecord({
                  tag: EEnum('h2'),
                  styleBlockIds: EList([
                    EText('9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4'),
                  ]),
                  children: EList([
                    EElement({
                      id: '16bb9436-a156-9391-7515-463d6d87c8c1',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText('Testimonial section title'),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: '8985a1d1-cff8-d020-a6a4-e8aae2a0c005',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('0da5eb9c-dac8-756b-6910-668b9c53e4a7'),
                  ]),
                  children: EList([
                    EElement({
                      id: '34d861a6-2980-2b1d-e730-216bd3f00704',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            medium: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 2'),
                                gridColumnEnd: EText('span 2'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            tiny: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('ad1be1ec-7948-18d5-2261-012dd6638a28'),
                        ]),
                        children: EList([
                          EElement({
                            id: '44b076b3-40b7-24bb-f72d-871ac1bed509',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageCards),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"62730e5b9765baa36e654ac5"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('e25834f0-be6f-1e0e-7ea1-d901244af2bf'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '6b15aced-5833-f336-d50b-934808261a1a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('d6bac0aa-e787-2945-e6fa-7a356339dd8f'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'd83ea7d0-f958-57e3-c6f9-3baf24b589d5',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Paragraph')
                                  ),
                                  data: ERecord({
                                    styleBlockIds: EList([
                                      EText(
                                        '1b2031fc-27bc-6bb0-9580-913bd9335308'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: 'd83ea7d0-f958-57e3-c6f9-3baf24b589d6',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          '\u201CAmet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat.\u201D'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '2502141a-22b9-36be-1b87-f25399d12160',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '52969e6b-e27c-4632-cdf8-e572f2a55aaa',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Heading')
                                        ),
                                        data: ERecord({
                                          tag: EEnum('h3'),
                                          styleBlockIds: EList([
                                            EText(
                                              'fb7f4207-fdf3-ac41-ce24-052261a1f39c'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '52969e6b-e27c-4632-cdf8-e572f2a55aab',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '66d7724a-c6fb-b07c-4def-1cb94da016cf',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          children: EList([
                                            EElement({
                                              id: '66d7724a-c6fb-b07c-4def-1cb94da016d0',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText(
                                                'Former VP of Company'
                                              ),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '66ec259d-f412-a861-a038-315d79fe9d8e',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('5eeec37a-7e99-2644-fdc0-ce3ab2158cdf'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'e40b51a7-818a-859e-c226-d78b81f7761f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('1b2031fc-27bc-6bb0-9580-913bd9335308'),
                              ]),
                              children: EList([
                                EElement({
                                  id: 'e40b51a7-818a-859e-c226-d78b81f77620',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CAmet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '78d86bcf-2617-bb4a-c812-6773a1cdf2b1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('c45069b3-fc3f-b87d-4ce4-6617c9174f38'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '56f44ae4-82c8-d092-522b-94987fa609c1',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62730e5b9765baa36e654aca"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '784ee53b-d93e-7a2b-cd8d-197caa88f54e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '264126c3-2ab8-a104-3190-0826e288488e',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          styleBlockIds: EList([
                                            EText(
                                              '67a6bd26-47c6-6cd9-a2d9-4943d79f7131'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '264126c3-2ab8-a104-3190-0826e288488f',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: 'ba876fcd-2f6d-4ce9-ca9f-ba90e048aedd',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          children: EList([
                                            EElement({
                                              id: 'ba876fcd-2f6d-4ce9-ca9f-ba90e048aede',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('VP of Company'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '0b6d3443-658e-060e-d79e-b13e4cc0b786',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('5eeec37a-7e99-2644-fdc0-ce3ab2158cdf'),
                        ]),
                        children: EList([
                          EElement({
                            id: '0b6d3443-658e-060e-d79e-b13e4cc0b787',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('1b2031fc-27bc-6bb0-9580-913bd9335308'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0b6d3443-658e-060e-d79e-b13e4cc0b788',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    '\u201CAmet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.\u201D'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '0b6d3443-658e-060e-d79e-b13e4cc0b789',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('c45069b3-fc3f-b87d-4ce4-6617c9174f38'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '0b6d3443-658e-060e-d79e-b13e4cc0b78a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62730e5b9765baa36e654aca"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'eee554db-e006-8dc8-ae3d-0f25db8d5e13'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '0b6d3443-658e-060e-d79e-b13e4cc0b78b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('div'),
                                    text: EBoolean(false),
                                    children: EList([
                                      EElement({
                                        id: '0b6d3443-658e-060e-d79e-b13e4cc0b78c',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          styleBlockIds: EList([
                                            EText(
                                              '67a6bd26-47c6-6cd9-a2d9-4943d79f7131'
                                            ),
                                          ]),
                                          children: EList([
                                            EElement({
                                              id: '0b6d3443-658e-060e-d79e-b13e4cc0b78d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('Author Name'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '0b6d3443-658e-060e-d79e-b13e4cc0b78e',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('Block')
                                        ),
                                        data: ERecord({
                                          text: EBoolean(true),
                                          tag: EEnum('div'),
                                          children: EList([
                                            EElement({
                                              id: '0b6d3443-658e-060e-d79e-b13e4cc0b78f',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('String')
                                              ),
                                              data: EText('VP of Company'),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '4fc4d513-ab34-d398-60a6-4d3b39c1c680',
      type: 'class',
      name: 'Testimonial Column Dark',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '9d78c9f2-a6ff-000f-04de-5c8b5b2ce3a4',
      type: 'class',
      name: 'Centered Heading',
      comb: '',
      styleLess: 'margin-bottom: 16px; text-align: center;',
      children: ['d857c47f-13ef-6c7e-7f97-30e5beebeba3'],
      variants: {tiny: {styleLess: 'margin-bottom: 24px;'}},
    },
    {
      _id: '0da5eb9c-dac8-756b-6910-668b9c53e4a7',
      type: 'class',
      name: 'Testimonial Grid',
      comb: '',
      styleLess:
        'display: grid; margin-top: 40px; grid-auto-columns: 1fr; grid-column-gap: 24px; grid-row-gap: 24px; grid-template-columns: 2.25fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-template-columns: 1fr 1fr;'},
        tiny: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: 'ad1be1ec-7948-18d5-2261-012dd6638a28',
      type: 'class',
      name: 'Testimonial Block Main',
      comb: '',
      styleLess:
        'display: flex; padding-top: 32px; padding-right: 24px; padding-bottom: 32px; padding-left: 24px; justify-content: space-between; background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {tiny: {styleLess: 'flex-direction: column;'}},
    },
    {
      _id: 'e25834f0-be6f-1e0e-7ea1-d901244af2bf',
      type: 'class',
      name: 'Testimonial Main Image',
      comb: '',
      styleLess:
        'width: 200px; height: 280px; margin-right: 24px; object-fit: cover;',
      children: [],
      variants: {
        medium: {styleLess: 'width: 300px; height: 350px;'},
        tiny: {
          styleLess:
            'width: 100%; height: auto; margin-right: 0px; margin-bottom: 32px;',
        },
        small: {styleLess: 'width: 250px;'},
      },
    },
    {
      _id: 'd6bac0aa-e787-2945-e6fa-7a356339dd8f',
      type: 'class',
      name: 'Testimonial Main Content',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: space-between;',
      children: [],
      variants: {},
    },
    {
      _id: '1b2031fc-27bc-6bb0-9580-913bd9335308',
      type: 'class',
      name: 'Margin bottom 24px',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: 'fb7f4207-fdf3-ac41-ce24-052261a1f39c',
      type: 'class',
      name: 'Testimonial Main Heading',
      comb: '',
      styleLess: 'margin-bottom: 2px; font-weight: 600;',
      children: [],
      variants: {},
    },
    {
      _id: '5eeec37a-7e99-2644-fdc0-ce3ab2158cdf',
      type: 'class',
      name: 'Testimonial Block',
      comb: '',
      styleLess:
        'display: flex; padding-top: 32px; padding-right: 24px; padding-bottom: 32px; padding-left: 24px; flex-direction: column; justify-content: space-between; background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {},
    },
    {
      _id: 'c45069b3-fc3f-b87d-4ce4-6617c9174f38',
      type: 'class',
      name: 'Testimonial Info Two',
      comb: '',
      styleLess: 'display: flex; align-items: center;',
      children: [],
      variants: {},
    },
    {
      _id: 'eee554db-e006-8dc8-ae3d-0f25db8d5e13',
      type: 'class',
      name: 'Testimonial Image',
      comb: '',
      styleLess:
        'width: 60px; height: 60px; margin-right: 16px; border-top-left-radius: 50%; border-top-right-radius: 50%; border-bottom-left-radius: 50%; border-bottom-right-radius: 50%; object-fit: cover;',
      children: ['ef5c9902-3a40-6a1b-9c7a-521d48c5e000'],
      variants: {},
    },
    {
      _id: '67a6bd26-47c6-6cd9-a2d9-4943d79f7131',
      type: 'class',
      name: 'Testimonial Author Name',
      comb: '',
      styleLess: 'font-weight: 700;',
      children: [],
      variants: {},
    },
  ],
} as const;
